export function getIsBrowserBuild(): boolean {
  return !!process.env.IS_BROWSER_BUILD;
}

export function getIsNodeBuild(): boolean {
  return !getIsBrowserBuild();
}
